import React from 'react';

import { fpga } from './payload';
import { ProductSection } from '../../spe-ne';

export const FPGASection = () => (
  <ProductSection id="spe-fpga" title="FPGA" payload={fpga} background="gray" arrowType="blue-arrow" />
);
